
import { mdiCheck, mdiTriangleSmallDown } from '@mdi/js'
import { mapState } from 'vuex'
import utils from '@/components/tools/utils'

export default {

  mdiCheck,
  mdiTriangleSmallDown,
  ignoredCountries: utils.excludedPhoneCountries.map(c => c[1]),
  props: {
    label: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    phoneNumberInUse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('general', {
      host: state => state.host
    }),
    defaultCountry () {
      const tld = this.host?.split?.('.').pop()
      if (tld === 'nl') {
        return 'nl'
      }
      if (tld === 'be') {
        return 'be'
      }
      if (tld === 'at') {
        return 'at'
      }

      return 'de'
    }
  },
  methods: {
    onInput (_, { number }) {
      this.$emit('input', number.international ?? '')
    },
    countryChanged (o) {
      this.$emit('country-changed', o.iso2)
    },

    clearEmailFromCookieAndGoToLogin () {
      this.$cookies.remove('vstepper_email')
      this.$store.commit('customer/unsetSimpleCustomerAttribute', 'email')

      this.$nextTick(async () => {
        await this.$router.push(this.localePath({
          name: 'auth-login'
        }))
      })
    }
  }
}
